export class MessagesAndInstructionsLang {
    public AddressDeleteMessage: string;
    public AppointmentAlreadyExistForNewBookingMessage: string;
    public AppointmentHasBeenConfirmedMessage: string;
    public AppointmentHasBeenConfirmedReturnMessage: string;
    public AppointmentInformation1Message: string;
    public AppointmentInformation2Message: string;
    public AppointmentTimeRangeMessage: string;
    public AvailabilityTypeSearchNotFoundMessage: string;
    public BarcodeUnreadableErrorMessage: string;
    public CantCheckinForLaterAppointmentMessage: string;
    public CantCheckinForLaterAppointmentsMessage: string;
    public CantCheckinForTheseAppointmentsMessage: string;
    public CantCheckinForThisAppointmentMessage: string;
    public CantCheckinProceedToReceptionInstruction: string;
    public ClickToStartInstruction: string;
    public ComeBackAtTimeToCheckinInstruction: string;
    public ConfirmAppointmentInstruction: string;
    public ConfirmSelectedAppointmentInstruction: string;
    public EmailDeleteMessage: string;
    public GreatNewsMessage: string;
    public HealthCardExpiredMessage: string;
    public HowWouldYourRateMessage: string;
    public InactivityMessage: string;
    public InvalidMessage: string;
    public IsThisCorrectMessage: string;
    public ManualInputInstructions: string;
    public MultiplePatientsFoundMessage: string;
    public MustSelectLanguageMessage: string;
    public NoAddressesFoundMessage: string;
    public NoAppointmentsFoundMessage: string;
    public NoAvailableAppointmentsMessage: string;
    public NoPatientsFoundMessage: string;
    public NoPharmacyAssociatedToFileMessage: string;
    public NotAbleToBookNewAppointmentMessage: string;
    public NotificationToReviewYourPrescriptionWillBeSent: string;
    public PatientCancelledCheckinMessage: string;
    public PatientInfoIncorrectMessage: string;
    public PharmacyOfferOnlinePrescriptionPlanning: string;
    public PhoneDeleteMessage: string;
    public PleaseSeeReceptionMessage: string;
    public PleaseSeeReceptionToUpdateInformationMessage: string;
    public PostalCodeCheckUnsuccessfulMessage: string;
    public ProcedeToWaitingRoomInstruction: string;
    public SelectAppointmentSearchTimeRangeInstruction: string;
    public SelectAvailabilityTypeInstruction: string;
    public SiteRequiredMessage: string;
    public ThankYouForUsingMyleKioskMessage: string;
    public UnableToStartApplicationMessage: string;
    public UnableToUpdateAppointmentStatusMessage: string;
    public UnableToUpdatePatientInformationMessage: string;
    public UnauthorizedAccessMessage: string;
    public UsbBarCodeInstructions: string;
    public WelcomeMessage: string;
}


// WEBPACK FOOTER //
// ./src/resources/MessagesAndInstructionsLang.ts